var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.185 30.5h5.523V16.835h4.606l.689-5.349h-5.295V8.08c0-1.544.428-2.598 2.644-2.598h2.808V.71A37.608 37.608 0 0012.044.5c-4.07 0-6.86 2.485-6.86 7.05v3.936H.597v5.35h4.589V30.5z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "95dea5ab26b8fb60023e9fc0d73db636.svg";
export { SvgFacebook as ReactComponent };